import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { getButtonConfig } from '../../functions/config-function';
import { ButtonComponent } from '@waseel-asp/tpa-waseel-lib-staging';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MimeTypeName } from '../../constants/mime-types';
import { MatCardModule } from '@angular/material/card';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ToastrHelperService } from '../../services/common/toast-helper.service';
import { HelperService } from '../../services/common/helper.service';

@Component({
  selector: 'app-document-viewer',
  standalone: true,
  imports: [CommonModule, MatDialogModule, ButtonComponent, TranslateModule, PdfViewerModule, MatCardModule, NgxJsonViewerModule],
  templateUrl: './document-viewer.component.html',
  styleUrl: './document-viewer.component.scss'
})
export class DocumentViewerComponent {
  data = inject(MAT_DIALOG_DATA);
  private sanitizer = inject(DomSanitizer);
  private translate = inject(TranslateService);
  private toastrHelperService = inject(ToastrHelperService);
  private helperService = inject(HelperService);

  safeUrl: SafeResourceUrl | null = null;
  pdfSrc: string;
  zoom: number = 1;
  closeButton = getButtonConfig(() => this.helperService.closeDialog(), 'close', 'icon', 'primary', '', true, null, 'close', null, null, null, ['close-btn']);
  zoomInButton = getButtonConfig(() => this.manageZoom(0.25), 'close', 'icon', 'primary', '', true, null, 'zoom_in', null, this.translate.instant('COMMON.ZOOM_IN'), null, ['btn-primary', 'btn', 'text-capitalize']);
  zoomOutButton = getButtonConfig(() => this.manageZoom(-0.25), 'close', 'icon', 'primary', '', true, null, 'zoom_out', null, this.translate.instant('COMMON.ZOOM_OUT'), null, ['btn-primary', 'btn', 'text-capitalize']);
  copyJsonButtonConfig = getButtonConfig(() => this.copyJson(), 'save', 'raised', 'primary', this.translate.instant('COMMON.COPY_JSON'), null, null, null, null, null, 'above', ['btn-primary', 'btn', 'text-capitalize']);

  constructor() {
    const data = this.data;
    if (!this.data.jsonObject) {
      if (this.data.mimeType === MimeTypeName.pdf)
        this.pdfSrc = this.data.blobUrl;
      else
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.blobUrl);
      if (this.data.mimeType.startsWith('image/')) {
        const img = new Image();
        img.src = this.data.blobUrl;
        img.onload = () => {
          const imageContainer = document.querySelector('.viewer-content') as HTMLElement;
          imageContainer.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
        };
      }
    }
  }

  public manageZoom(amount: number): void {
    this.zoom = Math.min(Math.max(this.zoom + amount, 0.5), 3);
  }

  private copyJson(): void {
    const jsonText = JSON.stringify(this.data.jsonObject, null, 2);
    navigator.clipboard.writeText(jsonText).then(() => this.toastrHelperService.showSuccessMessage('COMMON.JSON_COPIED'))
      .catch(() => this.toastrHelperService.showErrorMessage('FAILED_JSON_COPIED'));
  }
}